import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    createNewPassword: [],
    loading: false,
    error: null,
}

const createNewPasswordSlice = createSlice({
    name: "createNewPassword",
    initialState,
    reducers: {
        fetchCreateNewPasswordSucess: (state, action) => {
            state.loading = false
            state.createNewPassword = action.payload;
        },
        fetchCreateNewPasswordFailure: (state, action) => {
            state.loading = false
            state.error = action.payload;
        },
    },
})

export const {
    fetchCreateNewPasswordSucess,
    fetchCreateNewPasswordFailure,
} = createNewPasswordSlice.actions;

export default createNewPasswordSlice.reducer;